// import { IAdmin } from "@/entities";
import { Module } from "vuex";
import { IActions, IGetters, IMutations, IAdminState } from "./admin.type";

export const getters: IGetters = {
    getUser: (state) => {
        return state.user;
    },
};

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    },
    setUser: (state, payload) => {
        state.user = payload;
    },
    setGroups: (state, payload) => {
        state.groups = payload;
    },
};

export const actions: IActions = {
    async fetchUser(this, context): Promise<void> {
        try {
            context.commit("setLoading", true);
            const user = await this.$services.admin.getUserList();

            // use for attribute migration only
            // for (let index = 0; index < user.length; index++) {
            //     // sync user
            //     console.log("user:", user[index]);

            //     if (user[index].Attributes) {
            //         let id;
            //         for (let j = 0; j < user[index].Attributes!.length; j++) {
            //             if (user[index].Attributes![j].Name == "sub") {
            //                 id = user[index].Attributes![j].Value;
            //             }
            //         }
                    
            //         let firstname; 
            //         for (let j = 0; j < user[index].Attributes!.length; j++) {
            //             if (user[index].Attributes![j].Name == "custom:firstname") {
            //                 firstname = user[index].Attributes![j].Value;
            //             }
            //         }
                    
            //         let lastname; 
            //         for (let j = 0; j < user[index].Attributes!.length; j++) {
            //             if (user[index].Attributes![j].Name == "custom:lastname") {
            //                 lastname = user[index].Attributes![j].Value;
            //             }
            //         }

            //         let branch; 
            //         for (let j = 0; j < user[index].Attributes!.length; j++) {
            //             if (user[index].Attributes![j].Name == "custom:branch") {
            //                 branch = user[index].Attributes![j].Value;
            //             }
            //         }
            //         console.log(id, firstname, lastname, branch);

            //         const data: any = {}
            //         if(id){
            //             data["id"] = id;
            //         }

            //         if(firstname){
            //             data["firstname"] = firstname;
            //         }

            //         if(lastname){
            //             data["lastname"] = lastname;
            //         }

            //         if(branch){
            //             data["branch"] = branch;
            //         }

            //         if(user[index].Username){
            //             data["username"] = user[index].Username;
            //         }

            //         this.$services.sales.updateSale(data);
            //     }
            // }

            context.commit("setUser", user);
        } catch (err) {
            console.warn(err);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async disableUser(this, context, payload): Promise<void> {
        try {
            context.commit("setLoading", true);
            await this.$services.admin.disableUser(payload);
            const user = await this.$services.admin.getUserList();
            context.commit("setUser", user);
        } catch (err) {
            console.warn(err);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async enableUser(this, context, payload): Promise<void> {
        try {
            context.commit("setLoading", true);
            await this.$services.admin.enableUser(payload);
            const user = await this.$services.admin.getUserList();
            context.commit("setUser", user);
        } catch (err) {
            console.warn(err);
        } finally {
            context.commit("setLoading", false);
        }
    },

    async fetchGroups(this, context): Promise<void> {
        try {
            context.commit("setLoading", true);
            const { Groups } = await this.$services.admin.getListGroup();
            const groups = Groups?.map((g) => {
                return g.GroupName;
            });
            context.commit("setGroups", groups);
        } catch (err) {
            console.warn(err);
        } finally {
            context.commit("setLoading", false);
        }
    },
};

const admin: Module<IAdminState, IAdminState> = {
    namespaced: true,
    state: {
        loading: true,
        user: [],
        groups: [],
    },
    getters,
    mutations,
    actions,
};

export default admin;
